<template>
	<div class="recharge-user">
		<div class="index-view-top">
			<div style="flex: 1">
				<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			</div>
			<div style="flex: 1" class="title">{{ $t("head.recharge") }}</div>
			<div style="flex: 1" class="recharge-code" @click="withdrawalRecord">
				<p>{{ $t("head.top_up") }}</p>
			</div>
		</div>
		<div class="bizhong">
			{{ $t("vip.bz") }}
		</div>
		<div class="xuanze">
			<div @click="icon = 'TRX_USDT'" :class="icon == 'TRX_USDT' ? 'xuanze-icon' : ''">
				<p>USDT</p>
			</div>
			<div @click="icon = 'TRX'" :class="icon == 'TRX' ? 'xuanze-icon' : ''">
				<p>TRX</p>
			</div>
		</div>
		<van-cell-group inset style="margin:15px">
			<van-field v-model="account" :placeholder="tips1" />
		</van-cell-group>
		<div class="recharge-main">
			<div class="title">{{ $t("recharge.Chain_type") }}：TRC20</div>
			<div class="QR_code">
				<div class="address">{{ $t("recharge.address") }}</div>
				<div class="code">
					<div id="qrCode" ref="qrCodeDiv"></div>
				</div>
				<div class="address">{{ address }}</div>
				<div class="nowLogin">
					<div @click="copy(address)">
						<p>{{ $t("recharge.copy_address") }}</p>
					</div>
				</div>
				<div class="nowLogin">
					<div @click="xiayibu">
						<p>{{ $t("vip.xyb") }}</p>
					</div>
				</div>
			</div>
			<div class="tips">
				<p style="color: #ffffff">{{ $t("recharge.remind") }}：</p>
				<p v-html="articleDetails"></p>
			</div>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import {
	recharge, article
} from "@/utils/request";
export default {
	data() {
		return {
			address: "",
			articleDetails: "",//充值提示
			icon: 'TRX_USDT',
			tips1: this.$t("vip.je"),//要转移的数量
			account: ''
		};
	},
	mounted() {
		this.recharge()
		this.getArticle()
	},
	methods: {
		xiayibu() {
			if (this.icon && this.account) {
				this.$router.push({
					path: '/shangchuan',
					query: { icon: this.icon, account: this.account }
				})
			} else {
				this.$toast(this.$t("vip.je"));
			}

		},
		//充值提示
		getArticle() {
			article({ type: 'TIPS_DEPOSIT ' }).then((res) => {
				if (res.code == "200") {
					this.articleDetails = res.data.content
				}
			});
		},
		bindQRCode: function () {
			console.log(this.address)
			new QRCode(this.$refs.qrCodeDiv, {
				text: this.address,
				width: 160,
				height: 160,
				colorDark: "#000000", //二维码颜色
				colorLight: "#ffffff", //二维码背景色
				correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
			})
		},
		copy(Invitecode) {
			let url = Invitecode;
			let inputNode = document.createElement("input"); // 创建input
			inputNode.value = url; // 赋值给 input 值
			document.body.appendChild(inputNode); // 插入进去
			inputNode.select(); // 选择对象
			document.execCommand("Copy"); // 原生调用执行浏览器复制命令
			inputNode.className = "oInput";
			inputNode.style.display = "none"; // 隐藏
			this.$toast(this.$t("recharge.copy_success"));
		},
		recharge() {
			recharge().then((res) => {
				if (res.code == "200") {
					this.address = res.data.address
					this.$nextTick(function () {
						this.bindQRCode();
					})
				}
			});
		},
		withdrawalRecord() {
			this.$router.push("/balance");
		},
		toBack() {
			this.$router.go("-1");
		},
	},
};
</script>
<style>
.van-field__control {
	color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
.bizhong {
	font-size: 15px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #FFFFFF;
	padding: 15px;
}

.xuanze-icon {
	border: 1px solid #B6904D !important;
}

.van-cell {
	background: #110E31 !important;
	// background: #161414;
	//border-radius: 1.375rem;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
	border: unset;
}

/deep/.van-field__control {
	color: #ffffff !important;
}

/deep/.van-cell-group {
	// background: #161414;
	background: #110E31 !important;
	border-radius: 4px;
	color: #ffffff !important;
}

.xuanze {
	display: flex;
	padding: 0 15px;

	>div {
		width: 80px;
		height: 36px;
		border-radius: 5px;
		border: 1px solid #0c0b0b;
		margin-right: 10px;
		display: flex;
		align-items: center;
		justify-content: center;

		>p {
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #B6904D;
		}
	}
}

.recharge-user {
	width: 100vw;
	height: 100vh;
	background: #0c0b0b;

	.tips {
		padding-top: .625rem;

		>p {
			display: inline-block;
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			overflow: hidden;
			white-space: normal;
			word-break: break-all;
		}
	}

	.recharge-main {
		padding: 0.9375rem;

		.title {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffc400;
		}

		.QR_code {
			width: 100%;
			border-radius: 0.625rem;
			border: 0.0625rem solid #272727;

			.address {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;
				padding: 0.625rem 0;
			}

			.code {
				width: 180px;
				height: 180px;
				background: #ffffff;
				border-radius: 0.625rem;
				margin: 0 auto;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.nowLogin {
				padding: 0 1.875rem;
				margin-bottom: 0.9375rem;
				margin-top: 0.25rem;

				>div {
					width: 100%;
					height: 2.6875rem;
					background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
					border-radius: 1.375rem;
					display: flex;
					align-items: center;
					justify-content: center;

					>p {
						font-size: 0.9375rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #0c0b0b;
					}
				}
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
			text-align: center;
		}

		.recharge-code {
			display: flex;

			>p {
				margin-left: auto;
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/recharge.vue